'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { createTRPCClient, createWSClient, httpBatchLink, loggerLink, splitLink, wsLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { useState } from 'react';
import SuperJSON from 'superjson';
import { env } from '~/env';
import type { AppRouter } from '../../server/src/routers';
import { getQueryClient } from './query-client';

export const adminApi = createTRPCReact<AppRouter>();

export function AdminTRPCProvider(props: { children: React.ReactNode; cookies: string }) {
    const queryClient = getQueryClient();

    const [trpcClient] = useState(() => {
        const wsClient = createWSClient({
            url: `${env.NEXT_PUBLIC_WS_URL}/trpc`,
        });

        return createTRPCClient<AppRouter>({
            links: [
                loggerLink({
                    enabled: op =>
                        env.NODE_ENV === 'development' || (op.direction === 'down' && op.result instanceof Error),
                }),
                splitLink({
                    condition: op => op.type === 'subscription',
                    true: wsLink({
                        transformer: SuperJSON,
                        client: wsClient,
                    }),
                    false: httpBatchLink({
                        transformer: SuperJSON,
                        url: `${env.NEXT_PUBLIC_SERVER_URL}/trpc`,
                        fetch(url, options) {
                            return fetch(url, { ...options, credentials: 'include' });
                        },
                    }),
                }),
            ],
        });
    });

    return (
        <QueryClientProvider client={queryClient}>
            <adminApi.Provider client={trpcClient} queryClient={queryClient}>
                {props.children}
            </adminApi.Provider>
        </QueryClientProvider>
    );
}
